import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Command } from '../../../core/model/command';
import { ICommandHandler } from '../../../core/service/command/command-handler-resolver.service';
import { NativeWindowService } from '../../../core/service/native-window.service';
import { Observable } from 'rxjs';
import { EsignatureErrandService } from '../data/esignature-errand.service';
import { esignatureErrandCommand } from '../../command/esignature-errand.command';

@Injectable()
export class OpenESignatureDocumentCommandHandler implements ICommandHandler {
  constructor(
    private _service: EsignatureErrandService,
    private _nativeWindow: NativeWindowService
  ) {}

  canExecute(command: Command): boolean {
    return command.id === esignatureErrandCommand.openESignatureDocument && command.context;
  }

  execute(command: Command): Observable<void> {
    if (command instanceof Command) {
      return this._service.download(command.context).pipe(map(res => this._nativeWindow.save(res)));
    }
  }
}
